import React from 'react';
import { CalculationMode } from '../../types/gasTypes';

/**
 * Props interface for the ModeToggle component
 */
interface ModeToggleProps {
  /** Current calculation mode */
  calculationMode: CalculationMode;
  /** Handler for mode changes */
  onModeChange: (mode: CalculationMode) => void;
}

/**
 * ModeToggle Component
 * Provides a compact switch interface for switching between alcohol and octane calculation modes
 */
const ModeToggle: React.FC<ModeToggleProps> = ({
  calculationMode,
  onModeChange
}) => {
  // Handle toggle click
  const handleToggle = () => {
    const newMode = calculationMode === 'alcohol' ? 'octane' : 'alcohol';
    onModeChange(newMode);
  };

  return (
    <div className="space-y-3">
      {/* Selected Mode Display */}
      <div className="text-center">
        <div className="font-semibold text-base sm:text-lg" style={{ color: 'var(--text-primary)' }}>
          {calculationMode === 'alcohol' ? 'Alcohol Percentage' : 'Octane Rating'} Mode
        </div>
        <div className="text-xs sm:text-sm mt-1" style={{ color: 'var(--text-secondary)' }}>
          {calculationMode === 'alcohol' 
            ? 'Calculate mix for specific alcohol content' 
            : 'Calculate mix for specific octane rating'
          }
        </div>
      </div>

      {/* Toggle Switch */}
      <div className="flex items-center justify-center space-x-3">
        <span 
          className={`text-sm font-medium transition-colors ${
            calculationMode === 'octane' ? 'opacity-100' : 'opacity-50'
          }`}
          style={{ color: 'var(--text-primary)' }}
        >
          Octane
        </span>
        
        <button
          onClick={handleToggle}
          className="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2"
          style={{
            backgroundColor: 'var(--border-primary)'
          }}
        >
          <span
            className={`pointer-events-none absolute top-0.5 left-0.5 h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
              calculationMode === 'alcohol' ? 'translate-x-5' : 'translate-x-0'
            }`}
          />
        </button>
        
        <span 
          className={`text-sm font-medium transition-colors ${
            calculationMode === 'alcohol' ? 'opacity-100' : 'opacity-50'
          }`}
          style={{ color: 'var(--text-primary)' }}
        >
          Alcohol
        </span>
      </div>
    </div>
  );
};

export default ModeToggle;
